module.exports = __webpack_public_path__ + "static/media/mg8.949a392e.png";